import { CMSContentPage, IContentPage, useContentPageContext } from '@netfront/ekardo-content-library';
import { useEffect } from 'react';
import { PublicPage } from '../Page/PublicPage';
import { environmentVariables } from '@/utils/environmentVariables';
import { Container } from '../Container/Container';
import { Breadcrumbs } from '../Breadcrumbs/Breadcrumbs';
import Link from 'next/link';

const PublicContentPage = ({
  contentPage,
  pageUrl,
  showHeader = true,
}: {
  contentPage: IContentPage;
  pageUrl: string;
  showHeader?: boolean;
}) => {
  const { dispatch } = useContentPageContext();

  useEffect(() => {
    if (!pageUrl) {
      return;
    }

    dispatch({
      payload: {
        contentPage,
      },
      type: 'loadContentPage',
    });

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [pageUrl]);

  const renderPageContent = () => {
    if (showHeader) {
      return (
        <Container additionalClassNames="py-12">
          <div className="mb-2">
            <Breadcrumbs items={[{ content: <span>{contentPage.title}</span>, key: `${String(contentPage.id)}` }]} />
          </div>
          <h1 className="color-black text-uppercase mb-0">{contentPage?.title}</h1>

          <div className="flex flex-col">
            <CMSContentPage projectId={environmentVariables.projectId} />
          </div>
        </Container>
      );
    }

    return (
      <>
        <div
          style={{
            backgroundColor: '#FEFCDB'
          }}
        >
          <Container additionalClassNames='py-4 text-sm text-center'>
            <p>DAWN is in early access and actively being developed. Any feedback you provide will help us to continue improving the program. <Link href='/contact'>Share feedback</Link></p>
          </Container>
        </div>

        <CMSContentPage projectId={environmentVariables.projectId} />
      </>
    );
  };

  return (
    <PublicPage
      meta={{
        seoDescription: contentPage ? contentPage.seoDescription : '',
        seoTitle: contentPage ? contentPage.seoTitle : '',
      }}
      title={contentPage ? contentPage.title : ''}
    >
      <div className={showHeader ? '' : 'ek-cms-home'}>{renderPageContent()}</div>
    </PublicPage>
  );
};

export default PublicContentPage;
